import { LitEntity, html, css } from '../../utility/lit-entity';
import { StoreMixin } from '../../utility/store-mixin';
import { sharedStyles } from '../../styles/shared-styles';
import '../../organizations/parts/organization-ancestors-bread-crumbs';
import '../../organizations/parts/organization-dropdown';

class SchedulerUsers extends StoreMixin(LitEntity) {
  constructor() {
    super();
    this.users = [];
  }

  static get properties() {
    return {
      orgId: { type: String, attribute: false },
      users: { type: Array, attribute: false },
      usersHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      organization-ancestors-bread-crumbs {
        --last-crumb-overflow: visible;
        margin: 0 var(--root-margin);
      }
    `];
  }

  render() {
    return html`
      <lit-entity .href="${this.orgId}" @update="${this._onUpdateOrg}"></lit-entity>
      <lit-entity .href="${this.usersHref}" @update="${this._onUpdateUsers}"></lit-entity>

      <h1>Installers</h1>

      <organization-ancestors-bread-crumbs
        .href="${this.orgId}"
        linkPath="${window.location.pathname}"
        ancestorMinIndex="0"
      >
        <organization-dropdown dest="${window.location.pathname}" .href="${this.orgId}"></organization-dropdown>
      </organization-ancestors-bread-crumbs>

      ${this.users.map((user) => this._renderUser(user))}
    `;
  }

  _renderUser(user) {
    const userId = this.getHref('self', user);
    return html`
      <bn-card href="/scheduler/user?userId=${encodeURIComponent(userId)}">
        <h3>${user.properties.name}</h3>
      </bn-card>
    `;
  }

  _onUpdateOrg(e) {
    const { entity } = e.detail;
    this.usersHref = this.getHref('https://api.binsentry.com/rel/users', entity);
  }

  _onUpdateUsers(e) {
    const { entity } = e.detail;
    this.users = entity?.getSubEntitiesByClass('user') || [];
  }

  _stateChanged({ query }) {
    this.orgId = (query || {}).orgId || this.href;
  }
}

customElements.define('scheduler-users', SchedulerUsers);
